module.exports = __webpack_public_path__ + "img/map-solid.5f86376a.svg";